export default __webpack_public_path__ + "static/media/john.482004d0.jpg";